const IDENTITY_MAX_LENGTH = 120;
const RAW_MESSAGE_MAX_LENGTH = 500;
const URL_PATTERN = /[a-z][a-z0-9+.-]*:\/\/\S+/gi;
const EMAIL_PATTERN = /[^\s@]+@[^\s@]+\.[^\s@]+/g;
const WORD_WITH_DIGIT = /[\w-]*\d[\w-]*/g;

const stringField = (error: unknown, field: 'name' | 'message'): string => {
  if (typeof error !== 'object' || error === null) return '';
  const value = (error as Record<string, unknown>)[field];
  return typeof value === 'string' ? value : '';
};

export const errorIdentity = (error: unknown): string => {
  const name = stringField(error, 'name') || 'Error';
  const message = stringField(error, 'message').slice(0, RAW_MESSAGE_MAX_LENGTH);
  return `${name}: ${message}`
    .replace(URL_PATTERN, '<url>')
    .replace(EMAIL_PATTERN, '<email>')
    .replace(WORD_WITH_DIGIT, '#')
    .replace(/\s+/g, ' ')
    .slice(0, IDENTITY_MAX_LENGTH);
};
